
<template>
  <div class="music-player">
{{max}}

    <el-input  placeholder="请输入QQ号" v-model="qq"/>
    <el-button @click="getqq">获取QQ信息</el-button>
    <el-button @click="getredommusic">获取随机音乐</el-button>
    <audio id="Audio" controls>
      <source :src="redommusic" type="audio/mpeg" />
      <source src="myAudio.ogg" type="audio/ogg" />
      <p>
        Your browser doesn't support HTML5 audio. Here is a
        <a :href="redommusic">link to the audio</a> instead.
      </p>
    </audio>

    <img id="myImage" width="40px" src="https://api-storage.4ce.cn/v1/b137d74f2935897517e9b225e021711b.jpg"/>
  </div>
  <input type="file" id="fileInput" />
  <el-icon><PictureFilled /></el-icon>
  <ul style="align-items: start;text-align: start">
  <li>QQ等级：{{QQ.level}}</li>
  <li>QQ天数：{{QQ.login_days}}</li>
  <li>QQ昵称：{{QQ.nickname}}</li>
  <li>QQ号：{{QQ.user_id}}</li>
  <li>性别：{{QQ.sex}}</li>
  <li>年龄：{{QQ.age}}</li>
  <li>QQ签名：{{QQ.sign}}</li>
  </ul>
  <div>
    {{onurl}}
    <a :href="onurl">下载</a>
    <el-upload
        class="upload-demo"
        action="https://localhost:8090/hsq/file/imgupload"

        :on-success="handleUploadSuccess"



    >
      <template v-slot:file>{{fileList}}</template>
      <el-button  size="small" type="primary">选择文件</el-button>
    </el-upload>
    <el-button size="small" type="success" @click="convertToBase64">转换为Base64</el-button>
  </div>
<div>
  <pre style="text-align: left;">{{txt}}</pre>
  <div style="position: relative; height: 80vh ;z-index: 1">
    <div style="position: absolute; bottom:0; width: 100%;">
<el-input v-model="acc" id="screen"></el-input>
      {{users.username}}
      <el-button @click="tijiao(this.users.username)"></el-button>
      <el-button @click="q"></el-button>
</div>
  </div>
</div>
<button @click="startlisten">开始录音</button>
<button @click="stoplisten">停止录音</button>
</template>

<style scoped>


</style>
<script>

import axios from "axios";
import request from "@/utils/request";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Gpt",

  data(){
    return{
      A:"https://m701.music.126.net/20240106120100/0c03a1f433e47a8d48ab84cacd65ccc5/jdymusic/obj/wo3DlMOGwrbDjj7DisKw/32407183500/6394/1351/4861/83b73fd63b25dc22952b295aeb052bb0.mp3",
      url:require("../../assets/1.jpg"),
      srcList : [require("../../assets/1.jpg")],
      acc:"",
      web:{},
      isSent: false, // 标记是否已经发送过消息
      txt:"",
      users:localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{},
      max:0,
      qq:"",
      QQ:"",
      fileList: [], // 上传的文件列表
      base64String: '', // 存储文件的Base64编码
      onurl:"",
      listen:{},
      redommusic:''
    }
  },
  methods:{
    playAudio() {
      const audio = this.$refs.audio;
      audio.play();
    },
    q(){
      // 创建 XMLHttpRequest 对象
      var xhr = new XMLHttpRequest();

// 监听加载进度事件
      xhr.addEventListener("progress", function(event) {
        if (event.lengthComputable) {
          var percentComplete = (event.loaded / event.total) * 100;
          console.log(event)
          console.log("加载进度：" + percentComplete.toFixed(2) + "%");

          // 更新页面上的进度条或加载提示
          // 示例中使用了 id 为 progress 的元素作为进度条

        }
      });

// 发送图片请求
      xhr.open("GET", "https://api.vvhan.com/api/view?type=json");
      xhr.send();
    },
    changbackground(){
      axios.get("https://api.vvhan.com/api/view?type=json").then(res=>{
        console.log(res.data.imgurl)
        this.backgrounds = res.data.imgurl;
      })
    },
    // qq查询
    getqq(){
      console.log(this.qq)
      const Q="https://api.pearktrue.cn/api/qq/query.php?qq="+this.qq;
      console.log(Q)
      axios.get(Q).then(res=>{
        this.QQ=res.data.data;
      }
      )
    },
    getmusic(){
      const musicPlayer = document.querySelector('.music-player');

      const createAndPlayButton = document.getElementById('create-and-play-btn');
      const image = document.getElementById("myImage");
      let audioPlayer;
      let isPlaying = false;
      createAndPlayButton.addEventListener('click', () => {
        if (audioPlayer) {
          audioPlayer.pause();
          musicPlayer.removeChild(audioPlayer); // 删除之前的音频元素
          audioPlayer = document.createElement('audio');
          audioPlayer.src = 'https://api.vvhan.com/api/rand.music?sort=热歌榜';
          musicPlayer.insertBefore(audioPlayer, image); // 将新的音频元素插入到播放器容器中

          audioPlayer.play();
        } else {
          // 创建新的音频元素
          audioPlayer = document.createElement('audio');
          audioPlayer.src = 'https://api.vvhan.com/api/rand.music?sort=热歌榜';
          musicPlayer.appendChild(audioPlayer); // 将新的音频元素添加到播放器容器中
          audioPlayer.play(); // 播放音频
        }
        audioPlayer.addEventListener('play', () => {
          isPlaying=true;
          image.classList.toggle("rotate");
        });

        audioPlayer.addEventListener('pause', () => {
          isPlaying=false;
          image.classList.toggle("rotate");
        });
      });



      image.addEventListener('click', () => {
        if (isPlaying) {
          audioPlayer.pause();

        } else {
          audioPlayer.play();

        }
      });

    },
    getredommusic(){
      request.get('/music/redommusic').then(res=>{
        this.redommusic=res.data[0].url
        const audioElement = document.getElementById("Audio");
        audioElement.src = this.redommusic;

      })
    },
  downloadFile(data, fileName) {
  const blob = new Blob([data]);
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
},
    handleBeforeUpload(file) {
      // 在 before-upload 钩子中将文件添加到 fileList 中
      this.fileList.push(file);


    },
    handleUploadSuccess(file){
      this.fileList.push(file);

      this.onurl='https://localhost:8090/hsq/file/'+file.data;
      fetch(this.onurl)
          .then(response => {
            const contentDisposition = response.headers.get('content-disposition');
            const [, fileName] = contentDisposition.split(';').map(item => item.trim());

            console.log(fileName); // 输出文件名
            // 在这里可以根据需要进行后续处理
          });

    },

    convertToBase64() {
      const reader = new FileReader();
      const file = this.fileList[0];

      reader.onload = (e) => {
        this.base64String = e.target.result;
        console.log('Base64编码结果:', this.base64String);
      };

     console.log(file)
    },

    tijiao(name){


      var message = JSON.stringify(this.users);
      this.web.send(message);
      this.web.onmessage = function (event) {
        this.get = event.data;
        console.log(event)
        console.log(name+":"+ event.data)

      };

      this.web.onclose = function () {
        console.log("WebSocket Connection Closed");
      };


    },
   startlisten(){

     const recognition = new window.webkitSpeechRecognition();
// 找到屏幕上的元素
     const screenElement = document.getElementById('screen');
     // 设置语言为中文（根据需要调整）
     recognition.lang = 'zh-CN';
     recognition.start()
     this.listen=recognition
     // 监听语音识别结果
     recognition.onresult = function(event) {
       const transcript = event.results[0][0].transcript;
       console.log('识别结果:', transcript);
       // 将识别结果添加到屏幕元素中
       screenElement.value += transcript;
     };

// 监听语音识别错误
     recognition.onerror = function(event) {
       console.error('语音识别错误:', event.error);
     };

// 停止语音识别
     recognition.onend = function() {
       console.log('语音识别结束');
     };


   },
    stoplisten(){
      this.listen.stop();
    },

  },
  computed: {
    resData() {
      return this.$store.state.resData;
    },
  },
  mounted() {
    this.txt = this.resData;
    // 录音部分
    setTimeout(() => {
      const recognition = new window.webkitSpeechRecognition();
      recognition.lang = 'zh-CN';
      // 创建变量来表示是否正在录音
      let isRecording = false;
      const screenElement = document.getElementById('screen');
// 监听键盘按下事件
      document.addEventListener('keydown', function(event) {
        // 检查按下的键是否为空格键，并且当前不在录音状态
        if (event.code === 'Space' && !isRecording) {
          recognition.start();
          isRecording = true;
        }
      });

// 监听键盘抬起事件
      document.addEventListener('keyup', function(event) {
        // 检查抬起的键是否为空格键，并且当前在录音状态
        if (event.code === 'Space' && isRecording) {
          recognition.stop();
          isRecording = false;
        }
      });

// 监听语音识别结果
      recognition.onresult = function(event) {
        const transcript = event.results[0][0].transcript;
        console.log('识别结果:', transcript);
        // 将识别结果添加到屏幕元素中
        screenElement.value += transcript;
      };

// 监听语音识别错误
      recognition.onerror = function(event) {
        console.error('语音识别错误:', event.error);
      };

// 停止语音识别
      recognition.onend = function() {
        console.log('语音识别结束');
      };


    },1000)
    // this.getmusic();
  }
}
</script>
